module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.values),
      expression: "values"
    }],
    attrs: {
      "placeholder": _vm.defaulttext,
      "maxlength": "60"
    },
    domProps: {
      "value": (_vm.values)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.values = $event.target.value
      }, _vm.inputFn]
    }
  }, [_vm._v(_vm._s(_vm.values))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb4f2202","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/textarea/src/textarea.vue
// module id = 562
// module chunks = 0